// extracted by mini-css-extract-plugin
export var footer = "_qf-5";
export var fulfillmentInput = "_qf-0";
export var shipDateInput = "_qf-1";
export var shipmentModal = "_qf-2";
export var shipmentModalContent = "_qf-3";
export var tableContainer = "_qf-4";